import * as Highcharts from 'highcharts'

const fontFamily =
  // eslint-disable-next-line max-len
  ' "メイリオ", Meiryo, "游ゴシック", "Yu Gothic", YuGothic, "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", sans-serif '

let chart = null

Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
})

const breakPoint = (isResponsive) => window.innerWidth > 640 || !isResponsive

export function makeChart(id, series, startAge, turningAge, interest1, interest2, isResponsive) {
  chart = null
  // TODO デザイン (margin)
  const _marginTop = 100
  const _marginLeft = 80
  const _marginRight = 60
  const _marginBottom = 100
  const _highlightAge = 100
  const _endAge = 120
  const _dataLength = _endAge - startAge
  const _tickTotal = 10
  const _tickUnit = calcTickUnit(_dataLength, _tickTotal, isResponsive)
  const options = {
    chart: {
      marginTop: breakPoint(isResponsive) ? _marginTop : _marginTop - 10,
      marginLeft: breakPoint(isResponsive) ? _marginLeft : _marginLeft - 10,
      marginRight: breakPoint(isResponsive) ? _marginRight : 20,
      marginBottom: breakPoint(isResponsive) ? _marginBottom : _marginBottom - 40,
      height: 450,
      backgroundColor: '#fdfbf7',
      borderRadius: 10,
      shadow: true,
      style: { fontFamily: fontFamily },
      width: isResponsive ? null : 1110, // TODO デザイン
      styleMode: true,
    },
    legend: {
      align: 'left',
      verticalAlign: 'top',
      layout: 'horizontal',
      itemStyle: { fontSize: '1.6rem', fontWeight: 'noraml' },
      x: 20,
      y: 10,
    },
    tooltip: {
      shared: true,
      backgroundColor: '#ffebee',
      borderRadius: 20, // TODO デザイン
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      followTouchMove: true,
      crosshairs: true,
      // TODO positioner 修正 // チャートエリア左上暫定対応
      positioner: function (labelWidth, labelHeight, point) {
        let tooltipX, tooltipY
        const chart = this.chart
        const _plotX = point.plotX + _marginLeft
        const diffWidth = _plotX - chart.plotLeft
        const diffRatio = point.plotX / chart.plotSizeX
        if (_plotX - labelWidth < chart.plotLeft) {
          // 画面左のツールチップX軸
          if (diffWidth < labelWidth / 2) {
            tooltipX = _plotX - diffWidth
          } else {
            tooltipX = _plotX - labelWidth / 2
          }
        } else if (_plotX > chart.plotSizeX * 0.5 && _plotX - diffRatio * labelWidth > 0) {
          // 画面右のツールチップX軸
          tooltipX = _plotX - diffRatio * labelWidth
        } else {
          tooltipX = _plotX - labelWidth / 2
        }
        tooltipY = point.plotY - labelHeight + _marginTop
        if (tooltipY <= 0) {
          tooltipY = 0
        }
        return {
          x: tooltipX,
          y: tooltipY,
        }
      },
      formatter: function () {
        if (this.x !== '' && this.x !== ' ') {
          const idx = this.x
          const age = startAge + idx
          const depositPoint = this.points[0]
          const amountPoint1 = this.points[1]
          const amountPoint2 = this.points[2]
          // TODO デザイン
          return `<div class="tooltip-inner"><div class="tooltip-inner-box">
            <p class="tooltip-ttl">${age}歳</p><hr color="#f98197">
            <table><tr><td><span class="symbol1"></span></td>
            <td>運用しない場合:</td>
            <td>${depositPoint.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 円</td></tr>
            <tr><td class="total"><span class="symbol1"></span><span class="symbol2"></span></td>
            <td>${interest1}%で運用した場合:</td>
            <td>${amountPoint1.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 円</td></tr>
            <tr><td><span class="symbol2"></span></td>
            <td>${interest2}%で運用した場合:</td>
            <td>${amountPoint2.y
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 円</td></table></div></div>`
        } else {
          return false
        }
      },
    },
    credits: {
      enabled: false,
    },
    title: { text: '' },

    xAxis: {
      tickPositioner: function () {
        const positions = []
        for (let i = 0; i < _dataLength; i++) {
          const age = i + startAge
          if (!!turningAge && age === turningAge) positions.push(i)
          else if (age === _highlightAge) positions.push(i)
          else if (i % _tickUnit === 0) positions.push(i)
        }
        return positions
      },
      labels: {
        useHTML: true,
        formatter: function () {
          const age = this.value + startAge
          if (breakPoint(isResponsive)) {
            // _tickUnit と係数倍でない時にはハイライトする年齢は等間隔の目盛り線上に配置されるないのでy軸をずらす
            const marginStr = this.value % _tickUnit === 0 ? '' : 'margin-top:30px;'
            const tickClass =
              this.value % _tickUnit === 0
                ? 'reversalChart turningAge'
                : 'reversalChart turningAge bottom_1'
            if (!!turningAge && age === turningAge) {
              return `<div style="${marginStr}border: solid 2px #62a598;border-radius: 3px;">
                    <div style="background-color: #62a598;text-align:center;" class="${tickClass}">
                    <span style="color:#fdfbf7;text-shadow:none;font-size:1.6rem;">
                    ${age}歳</span></div></div>`
            }
            if (age === _highlightAge) {
              // turningAge と _highlighAge の値が近く、なおかつどちらも等間隔の目盛り線上にない場合はさらにy軸をずらす
              const highlightMarginStr = () => {
                if (
                  marginStr !== '' &&
                  !!turningAge &&
                  _highlightAge - turningAge < _tickUnit &&
                  (turningAge - startAge) % _tickUnit !== 0
                ) {
                  return 'margin-top:60px;'
                } else {
                  return marginStr
                }
              }

              const highlightTickClass = () => {
                if (
                  marginStr !== '' &&
                  !!turningAge &&
                  _highlightAge - turningAge < _tickUnit &&
                  (turningAge - startAge) % _tickUnit !== 0
                ) {
                  return 'reversalChart highlightAge bottom_2'
                } else if (marginStr !== '') {
                  return 'reversalChart highlightAge bottom_1'
                } else {
                  return 'reversalChart highlightAge'
                }
              }
              return `<div style="${highlightMarginStr()}border:solid 2px #f98197;
                    border-radius:3px;">
                    <div style="background-color: #f98197;text-align:center;"
                    class="${highlightTickClass()}">
                    <span style="color:#fdfbf7;text-shadow:none;font-size:1.6rem;">
                    ${age}歳</span></div></div>`
            }
            return `<span style="color:#000;text-shadow:none;font-size:1.2rem;">${age}歳</span>`
          } else {
            const marginStr = this.value % _tickUnit === 0 ? '' : 'margin-top:15px;'

            // turningAge と _highlighAge の値が近く、なおかつどちらも等間隔の目盛り線上にない場合はさらにy軸をずらす
            const highlightMarginStr = () => {
              if (
                marginStr !== '' &&
                !!turningAge &&
                _highlightAge - turningAge < _tickUnit &&
                (turningAge - startAge) % _tickUnit !== 0
              )
                return 'margin-top:30px;'
              else return marginStr
            }
            if (marginStr === '')
              return `<span style="color:#000;text-shadow:none;font-size:1.2rem;">
                    ${age}歳</span>`
            else if (age === _highlightAge)
              return `<div style="color:#000;text-shadow:none;font-size:1.2rem;
                    ${highlightMarginStr()}">${age}歳</div>`
            else
              return `<div style="color:#000;text-shadow:none;font-size:1.2rem;
                    ${marginStr}">${age}歳</div>`
          }
        },
      },
    },
    yAxis: {
      min: 0,
      gridLineColor: '#e8e8e8',
      labels: {
        style: {
          color: '#43425D',
          fontSize: '1.2rem',
        },
        formatter: function () {
          return (this.value / 10000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
      },
      title: {
        text: '(万円)',
        rotation: 0,
        align: 'high',
        offset: 20,
        style: {
          color: '#43425D',
        },
        y: -10,
      },
    },
    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        lineWidth: 3,
        pointStart: startAge,
      },
      line: {
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    series: series,
  }

  chart = Highcharts.chart(id, options)
  return chart
}

export function resetChart() {
  if (chart) {
    chart.destroy()
    chart = null
  }
}

function calcTickUnit(dataLength, tickTotal, isResponsive) {
  const tickRawUnit = dataLength / tickTotal
  const coefficient = !breakPoint(isResponsive) ? 2 : 1
  switch (true) {
    case tickRawUnit >= 10:
      return 10 * coefficient
    case tickRawUnit >= 5:
      return 5 * coefficient
    case tickRawUnit >= 3:
      return 3 * coefficient
    case tickRawUnit >= 2:
      return 2 * coefficient
    default:
      return 1 * coefficient
  }
}
